import React from 'react';
import { Field } from 'formik';
import { pipe } from 'ramda';

import Select from './Select';
import { withLabel, withFormGroup, withError } from '../hocs';

const LabeledSelect = pipe(
  withLabel,
  withFormGroup,
)(props => <Field {...props} component={withError(Select)} />);

export default LabeledSelect;


// WEBPACK FOOTER //
// ./src/components/formik/LabeledSelect.jsx